// extracted by mini-css-extract-plugin
module.exports = {"Dialog":"Drawer_Dialog__3ZE53","titleWrapper":"Drawer_titleWrapper__jSTRe","dialogBody":"Drawer_dialogBody__1EzlJ"};